import { cn } from '@bliks-io/ui';
import { useTranslation } from 'react-i18next';

// DICIS issues a live verification seal: the image is hot-linked from their
// server (reflects revocation) and the badge links back to our public profile.
const DICIS_PROFILE_URL = 'https://profile.dicis.org/Bliks-IO-GmbH';
const DICIS_BADGE_URL =
  'https://profile.dicis.org/uploads/zert/bca57326-001a-4e56-a5a2-6b0c04f9573b.png';

export function CertificationBadges({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'mx-auto flex w-fit max-w-full flex-wrap items-center justify-center gap-4',
        className
      )}
    >
      {/* DICIS seal ships on a solid white background, so it blends on the
          white column without any wrapper. */}
      <a
        href={DICIS_PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
        title={t('certDicisTitle')}
      >
        <img src={DICIS_BADGE_URL} alt={t('certDicisAlt')} className="h-9 w-auto" />
      </a>

      {/* DSGVO badge has white text, so it gets its own dark backing. */}
      <span className="flex items-center rounded-lg bg-[#0a0a0a] px-2 py-1">
        <img
          src="/assets/images/dsgvo-konform.png"
          alt={t('certDsgvoAlt')}
          className="h-8 w-auto"
        />
      </span>

      {/* GoBD badge is a self-contained light pill. */}
      <img src="/assets/images/gobd-ready.png" alt={t('certGobdAlt')} className="h-9 w-auto" />
    </div>
  );
}
